var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner", attrs: { type: "primary" } },
    [
      _c(
        "div",
        {
          staticClass: "app-main-page",
          staticStyle: { height: "calc(100vh - 130px)" }
        },
        [
          _c("div", { staticClass: "app-main-inner-row" }, [
            _c(
              "div",
              { staticClass: "triggers" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.toQuery }
                  },
                  [_vm._v(_vm._s(_vm.$t("Information.Search")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.toAddSeaPortRequirement }
                  },
                  [_vm._v(_vm._s(_vm.$t("Information.Add")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.toUpdateSeaPortRequirement }
                  },
                  [_vm._v(_vm._s(_vm.$t("Information.Edit")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "danger" },
                    on: { click: _vm.toBatchDelSeaPortRequirement }
                  },
                  [_vm._v(_vm._s(_vm.$t("Information.Delete")))]
                ),
                _c("cargo-grid-state-btn", {
                  attrs: {
                    "grid-params": _vm.gridParams,
                    "config-module": "101340"
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "app-main-inner-row" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "100px",
                    "label-position": "left"
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Information.PortOfLoadingPOL")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              "callback-method-type": "value",
                              "default-value":
                                _vm.searchConditions.loadingPortCode,
                              "callback-params": { key: "loadingPortCode" }
                            },
                            on: { parentCallBack: _vm.getValueSearchFromChild }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Information.PortOfDischargePOD")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              "callback-method-type": "value",
                              "default-value":
                                _vm.searchConditions.dischargingPortCode,
                              "callback-params": { key: "dischargingPortCode" }
                            },
                            on: { parentCallBack: _vm.getValueSearchFromChild }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Information.PlaceOfDelivery")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              "callback-method-type": "value",
                              "default-value":
                                _vm.searchConditions.destinationPortCode,
                              "callback-params": { key: "destinationPortCode" }
                            },
                            on: { parentCallBack: _vm.getValueSearchFromChild }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Information.TransportationTerms")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_ShippingTerm,
                              "callback-method-type": "value",
                              "default-value": _vm.searchConditions.freightTerm,
                              "callback-params": { key: "freightTerm" }
                            },
                            on: { parentCallBack: _vm.getValueSearchFromChild }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Information.CargoType") } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CargoType,
                              "callback-method-type": "value",
                              "default-value": _vm.searchConditions.cargoType,
                              "callback-params": { key: "cargoType" }
                            },
                            on: { parentCallBack: _vm.getValueSearchFromChild }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "app-main-inner-row" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "100px",
                    "label-position": "left"
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Information.ShippingCompany")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": { seaCmp: true },
                              "callback-method-type": "value",
                              "default-value":
                                _vm.searchConditions.carrierId == 0
                                  ? ""
                                  : _vm.searchConditions.carrierId,
                              "callback-params": { key: "carrierId" }
                            },
                            on: { parentCallBack: _vm.getValueSearchFromChild }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Information.DestinationPortAgent")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "callback-method-type": "value",
                              "default-value":
                                _vm.searchConditions.destinationAgent == 0
                                  ? ""
                                  : _vm.searchConditions.destinationAgent,
                              "method-params": { overseaAgent: true },
                              "callback-params": { key: "destinationAgent" }
                            },
                            on: { parentCallBack: _vm.getValueSearchFromChild }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("Information.ShippingRoute") }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Region,
                              "callback-params": { key: "region" },
                              "callback-method-type": "value",
                              "default-value": _vm.searchConditions.region
                            },
                            on: { parentCallBack: _vm.getValueSearchFromChild }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "app-main-inner-row row-grid" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "101340",
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "app-main-inner-row row-pagination" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchConditions.total > 0,
                    expression: "searchConditions.total>0"
                  }
                ],
                attrs: {
                  total: _vm.searchConditions.total,
                  page: _vm.searchConditions.pageNum,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: _vm.fetchSeaPortRequirement
                }
              })
            ],
            1
          )
        ]
      ),
      _vm.isShowingSeaportRequirementForm
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                "custom-class": "",
                visible: _vm.isShowingSeaportRequirementForm,
                title: _vm.formTitle,
                width: "1000px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.isShowingSeaportRequirementForm = $event
                },
                close: _vm.cancel
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "padding-bottom": "10px" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        model: _vm.seaPortRequirement,
                        inline: "",
                        "label-width": "110px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "el-form-item-wrapper" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Information.DisplayRules")
                              }
                            },
                            [
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    model: {
                                      value: _vm.seaPortRequirement.mbl,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.seaPortRequirement,
                                          "mbl",
                                          $$v
                                        )
                                      },
                                      expression: "seaPortRequirement.mbl"
                                    }
                                  },
                                  [_vm._v("MBL")]
                                ),
                                _c(
                                  "el-checkbox",
                                  {
                                    model: {
                                      value: _vm.seaPortRequirement.hbl,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.seaPortRequirement,
                                          "hbl",
                                          $$v
                                        )
                                      },
                                      expression: "seaPortRequirement.hbl"
                                    }
                                  },
                                  [_vm._v("HBL")]
                                )
                              ]
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-form-item-wrapper",
                          staticStyle: { "padding-top": "10px" }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Information.PortOfLoadingPOL")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  "callback-method-type": "value",
                                  "default-multiple-value":
                                    _vm.seaPortRequirement.loadingPortCodeArray,
                                  "callback-params": {},
                                  multiple: ""
                                },
                                on: {
                                  parentCallBack: function(item) {
                                    return (_vm.seaPortRequirement.loadingPortCodeArray =
                                      item.value)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Information.PortOfDischargePOD")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  "callback-method-type": "value",
                                  "default-multiple-value":
                                    _vm.seaPortRequirement
                                      .dischargingPortCodeArray,
                                  "callback-params": {},
                                  multiple: ""
                                },
                                on: {
                                  parentCallBack: function(item) {
                                    return (_vm.seaPortRequirement.dischargingPortCodeArray =
                                      item.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-form-item-wrapper",
                          staticStyle: { "padding-top": "10px" }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Information.PlaceOfDelivery")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  "callback-method-type": "value",
                                  "default-multiple-value":
                                    _vm.seaPortRequirement
                                      .destinationPortCodeArray,
                                  "callback-params": {},
                                  multiple: ""
                                },
                                on: {
                                  parentCallBack: function(item) {
                                    return (_vm.seaPortRequirement.destinationPortCodeArray =
                                      item.value)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Information.ShippingRoute")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Region,
                                  "default-multiple-value":
                                    _vm.seaPortRequirement.regionCodeArray,
                                  "callback-params": {},
                                  multiple: ""
                                },
                                on: {
                                  parentCallBack: function(item) {
                                    return (_vm.seaPortRequirement.regionCodeArray =
                                      item.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-form-item-wrapper",
                          staticStyle: { "padding-top": "10px" }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Information.ShippingCompany")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": { seaCmp: true },
                                  "callback-method-type": "value",
                                  "default-value":
                                    _vm.seaPortRequirement.carrierId == 0
                                      ? ""
                                      : _vm.seaPortRequirement.carrierId,
                                  "callback-params": { key: "carrierId" }
                                },
                                on: { parentCallBack: _vm.getValueFromChild }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "Information.DestinationPortAgent"
                                )
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                key: 1,
                                staticStyle: { width: "300px" },
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "callback-method-type": "value",
                                  "default-value":
                                    _vm.seaPortRequirement.destinationAgent == 0
                                      ? ""
                                      : _vm.seaPortRequirement.destinationAgent,
                                  "method-params": { overseaAgent: true },
                                  "callback-params": { key: "destinationAgent" }
                                },
                                on: { parentCallBack: _vm.getValueFromChild }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-form-item-wrapper",
                          staticStyle: { "padding-top": "10px" }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("Information.TransportationTerms")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_ShippingTerm,
                                  "callback-method-type": "value",
                                  "default-value":
                                    _vm.seaPortRequirement.freightTerm,
                                  "callback-params": { key: "freightTerm" }
                                },
                                on: { parentCallBack: _vm.getValueFromChild }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("Information.CargoType") }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_CargoType,
                                  "callback-method-type": "value",
                                  "default-value":
                                    _vm.seaPortRequirement.cargoType,
                                  "callback-params": { key: "cargoType" }
                                },
                                on: { parentCallBack: _vm.getValueFromChild }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-form-item-wrapper",
                          staticStyle: { "padding-top": "10px" }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "Information.OperationalRequirements"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "730px" },
                                attrs: {
                                  type: "textarea",
                                  rows: 5,
                                  placeholder: _vm.$t(
                                    "Information.PleaseEnterTheContent"
                                  )
                                },
                                model: {
                                  value:
                                    _vm.seaPortRequirement
                                      .operationRequirements,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.seaPortRequirement,
                                      "operationRequirements",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "seaPortRequirement.operationRequirements"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showCloudFile,
                              expression: "showCloudFile"
                            }
                          ],
                          staticClass: "el-form-item-wrapper",
                          staticStyle: { "padding-top": "10px" }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "Information.AttachmentDescription"
                                )
                              }
                            },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "yibiao-tijiao" },
                                on: { click: _vm.appendixDescription }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.submitSeaPortRequirement }
                    },
                    [_vm._v(_vm._s(_vm.$t("Information.Confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.isShowingSeaportRequirementForm = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Information.Cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.cloudFile.job,
          lob: _vm.cloudFile.lob,
          "show-all": _vm.cloudFile.showAll
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadDone: _vm.onUploadDone
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }